export const AGENT_OPEN_ADD_MODAL = "AGENT_OPEN_ADD_MODAL";
export const AGENT_DETAIL_SUSPEND = "AGENT_DETAIL_SUSPEND";
export const AGENT_DETAIL_DELETE = "AGENT_DETAIL_DELETE";
export const AGENT_EDIT_SAVE = "AGENT_EDIT_SAVE";
export const AGENT_EDIT_CANCEL = "AGENT_EDIT_CANCEL";
